import React from 'react';
import { Popover } from 'antd';
import { CompactPicker } from 'react-color';

type PickerProps = { color: string } & Omit<React.ComponentProps<typeof CompactPicker>, 'color'>;

const ColourPicker: React.FC<PickerProps> = (props) => {
    const { color } = props;

    return (
        <Popover content={<CompactPicker {...props} />} trigger='click' placement='right'>
            <div
                style={{
                    padding: '0',
                    border: '1px solid white',
                    borderRadius: '0',
                    cursor: 'pointer',
                    display: 'inline-block',
                }}
            >
                <div style={{ width: '36px', height: '14px', borderRadius: '2px', backgroundColor: color }} />
            </div>
        </Popover>
    );
};

export default ColourPicker;
export { PickerProps };
